import React, { useState, useEffect } from 'react';
import { Phone, MoreVertical, Paperclip, Mic } from 'lucide-react';

const WhatsAppMockup = ({ type = 'hero' }) => {
  const scenarios = {
    hero: {
      messages: [
        { type: 'customer', text: 'Üyeliğim ne zaman bitiyor?' },
        { 
          type: 'bot', 
          text: 'Merhaba! Üyeliğiniz 15 Mart 2024 tarihinde sona eriyor. 📅' 
        },
        { 
          type: 'bot', 
          text: 'Şimdi yenilerseniz %15 indirim kazanırsınız! 🎉' 
        },
        { 
          type: 'bot', 
          text: 'Tek tıkla yenileyebilirsiniz:' 
        },
        { 
          type: 'bot-button', 
          text: '💳 Hemen Yenile ve %15 İndirim Kazan' 
        }
      ]
    },
    gym: {
      messages: [
        { type: 'bot', text: 'Merhaba Ahmet! Üyeliğiniz 3 gün sonra sona eriyor. ⏰' },
        { type: 'bot', text: 'Şimdi yenilerseniz kesintisiz devam eder ve %10 indirim kazanırsınız! 💪' },
        { type: 'bot-button', text: '🔥 Hemen Yenile' },
        { type: 'customer', text: 'Yenilemek istiyorum' },
        { type: 'bot', text: 'Harika! İşte ödeme linkiniz:' },
        { type: 'bot-button', text: '💳 Güvenli Ödeme (₺450)' }
      ]
    },
    spa: {
      messages: [
        { type: 'bot', text: 'Merhaba! Yarın saat 14:00 masajınız için uygun olur mu? 💆‍♀️' },
        { type: 'customer', text: 'Evet, müsaitim!' },
        { type: 'bot', text: 'Mükemmel! Rezervasyonunuz oluşturuldu. ✅' },
        { type: 'bot', text: '📅 Tarih: 16 Mart 2024\n⏰ Saat: 14:00\n💆‍♀️ Hizmet: İsveç Masajı (60dk)' },
        { type: 'bot', text: 'Randevunuzdan 1 gün önce hatırlatma göndereceğim! 😊' }
      ]
    },
    hotel: {
      messages: [
        { type: 'bot', text: 'Hoş geldiniz! Check-in işleminizi WhatsApp üzerinden tamamlayabilirsiniz. 🏨' },
        { type: 'bot-button', text: '✅ Online Check-In Yap' },
        { type: 'customer', text: 'Check-in yapmak istiyorum' },
        { type: 'bot', text: 'Harika! Odanız hazır:\n\n🚪 Oda: 305 (Deniz Manzaralı)\n🔑 Dijital Anahtar gönderildi' },
        { type: 'bot', text: 'Oda servisi için menüyü görmek ister misiniz?' }
      ]
    }
  };

  const currentScenario = scenarios[type] || scenarios.hero;
  const [showTyping, setShowTyping] = useState(false);

  // Simulate typing indicator animation
  useEffect(() => {
    const interval = setInterval(() => {
      setShowTyping(prev => !prev);
    }, 4000); // Toggle every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="phone-mockup hero-mockup">
      <div className="phone-frame">
        <div className="phone-screen">
          {/* Header - WhatsApp yeşil bar */}
          <header className="chat-header wa-header">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <div className="w-8 h-8 bg-gradient-to-br from-[#4A90E2] to-[#A4D65E] rounded-full"></div>
              </div>
              <div className="min-w-0">
                <div className="font-semibold text-sm truncate">Çevik Otomasyon</div>
                <div className="text-xs opacity-80">Online</div>
              </div>
            </div>
            <div className="flex items-center space-x-4 flex-shrink-0">
              <Phone className="h-5 w-5" />
              <MoreVertical className="h-5 w-5" />
            </div>
          </header>

          {/* Chat Body - Mesaj balonları */}
          <div className="chat-body">
            {currentScenario.messages.map((msg, idx) => {
              const animationStyle = { animationDelay: `${idx * 0.2}s` };
              return (
              <div
                key={idx}
                className={`message-wrapper ${msg.type === 'customer' ? 'message-right' : 'message-left'}`}
              >
                {msg.type === 'customer' ? (
                  <div className="wa-bubble-right message-bubble" style={animationStyle}>
                    <p className="text-sm text-gray-800 leading-relaxed">{msg.text}</p>
                    <div className="wa-timestamp text-right">14:32</div>
                  </div>
                ) : msg.type === 'bot-button' ? (
                  <div className="wa-button-message message-bubble" style={animationStyle}>
                    <div className="text-sm font-semibold text-[#075E54] text-center leading-snug">{msg.text}</div>
                  </div>
                ) : (
                  <div className="wa-bubble-left message-bubble" style={animationStyle}>
                    <p className="text-sm text-gray-800 leading-relaxed whitespace-pre-line">{msg.text}</p>
                    <div className="wa-timestamp text-right">14:32</div>
                  </div>
                )}
              </div>
            )})}
            
            {/* Typing Indicator - appears periodically */}
            {showTyping && (
              <div className="message-wrapper message-left">
                <div className="typing-indicator message-bubble">
                  <div className="typing-dot"></div>
                  <div className="typing-dot"></div>
                  <div className="typing-dot"></div>
                </div>
              </div>
            )}
          </div>

          {/* Input Bar - Alt kısım */}
          <footer className="chat-input-bar wa-input-bar">
            <button className="wa-input-icon">
              <Paperclip className="h-5 w-5 text-gray-600" />
            </button>
            <div className="wa-input-field">
              <input
                type="text"
                placeholder="Mesaj yazın"
                className="w-full outline-none text-sm bg-transparent"
                disabled
              />
            </div>
            <button className="wa-input-icon">
              <Mic className="h-5 w-5 text-gray-600" />
            </button>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppMockup;